import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { endpoints } from '../../shared/endpoints';
import { TournamentsResponse } from '../models/api/responses/tournaments.response';
import { Filter } from '../store/actions/allTournaments.action';

@Injectable({ providedIn: 'root' })
export class AllTournamentsService {
    constructor(private http: HttpClient) {}

    getAllTournaments(page: number, filters: Filter, pageSize?: number) {
        return this.http
            .get<TournamentsResponse>(
                endpoints.tournaments.children.getAllTournaments({
                    page,
                    filters,
                    pageSize,
                })
            )
            .pipe(shareReplay());
    }
}
